import React from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

function StatsTableView(data) {

    const type = JSON.parse(JSON.stringify(data.data.type));
    let choices = JSON.parse(JSON.stringify(type !=='notation'? (typeof data.data.choices!=='undefined'? data.data.choices: []) : (typeof data.data.stats!=='undefined'? data.data.stats : [])));
    let title =  JSON.parse(JSON.stringify(type !=='notation'? (typeof data.data.question!=='undefined'? data.data.question : '') : (typeof data.data.title!=='undefined'?data.data.title:'')));
    let globalNbVotes = typeof data.data.nbVotes!=='undefined' ? JSON.parse(JSON.stringify(data.data.nbVotes)):0;

    const generateHeaders = (type) => {
        
        let header = 'Nombre de votes;Répartition (%)';
    
       switch (type) {
        case 'survey':
            header = 'Choix;'+header;
            break
        case 'quizz':
            header = 'Choix;'+ header + ';Réponse';
            break;
        case 'notation':
            header = 'Note;' + header;
            break;
        default:
            break;
    }
    
    return header;
    
    }

    const extraColumns = (type) => {
        
        let columns = [];
    
       switch (type) {
        case 'survey':
            break;
        case 'quizz':
            //add choice propertyname
            columns.push('isCorrect');
            break;
        case 'notation':
            break;
        default:
            break;
    }
    
    return columns;
    
    }

    let headers = generateHeaders(type);
    let extraCols = extraColumns(type);

    
    const generateRows = (extraCols, choice, choicesLength) => {

        const entries = JSON.parse(JSON.stringify(choice.entries));
        const label = JSON.parse(JSON.stringify(choice.label));

        let averageRow = choice.average!== undefined ? `${label && choicesLength > 1 ? `${label} - ` : ''}Moyenne; ${choice.average},` : undefined;
        let totalVoteRow = choice.nbVotes !== undefined ? `${label && choicesLength > 1 ? `${label} - ` : ''}Total des votes; ${choice.nbVotes},` : undefined;

        let rows = entries.map(entry => {
            const name = entry.name;
            const nbVotes = typeof entry.nbVotes !== 'undefined' && entry.nbVotes !== null ? entry.nbVotes : 0;
            const percent = typeof entry.percent !== 'undefined'&& entry.percent !== null ? entry.percent : 0;
            let row = `${label && choicesLength > 1 ? `${label} - ` : ''} ${name};${nbVotes};${percent}`;
            extraCols.forEach(col => {
                row += ';'+entry[col];
                if (averageRow !== undefined){
                    averageRow+=";";
                }
                if (totalVoteRow !== undefined){
                    totalVoteRow+=';';
                }
              });
            return row;
        });

        if (typeof averageRow !== 'undefined'){
            rows.push(averageRow);
        }
        if (typeof totalVoteRow !== 'undefined'){
            rows.push(totalVoteRow);
        }

    return rows;

    }


    const generateFooter = (choices) => {
        let rows = [];
        let globalTotalVoteRow = ``;
        if (globalNbVotes !== undefined && choices.length > 1){
            globalTotalVoteRow = `Total des votes; ${globalNbVotes};`
            extraCols.forEach(col => {
                globalNbVotes+=";";
              });
        }
        rows.push(globalTotalVoteRow);
        return rows;
    }
    
     const handleExportCSV = (title, type, choices) => {
        const csvContent = 'data:text/csv;charset=utf-8,' + '\uFEFF' +
            headers + '\n' +
            choices.map(choice => {
                const rows = generateRows(extraCols, choice, choices.length);
                return rows.join('\n');
            }).join('\n') + '\n' + generateFooter(choices).join('\n');
    
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', type+'_'+title+'_dsas.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const tableHeaders = headers.split(';');
    

    return <>
     <div style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div></div>
                <div><Button onClick={() => handleExportCSV(title, type, choices)}>Export CSV</Button></div>
            </div>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                <TableRow>
                {tableHeaders.map((name) => (
                        <TableCell>{`${name}`}</TableCell>
                    ))}
                </TableRow>
                </TableHead>
                <TableBody>
                {choices && choices.length > 0 ? choices.flatMap((choice, choiceIndex) => [
                    
                    ...choice.entries.map((entry, entryIndex) => (
                        <TableRow key={`${choiceIndex}-${entryIndex}`} style={{ backgroundColor: choiceIndex % 2 === 1 ? '#f0f0f0' : 'transparent' }}>
                            <TableCell>{`${choice.label && choices.length > 1 ? `${choice.label} -` : ''} ${entry.name}`}</TableCell>
                            <TableCell>{`${typeof entry.nbVotes !== 'undefined' && entry.nbVotes !== null ? entry.nbVotes : 0}`}</TableCell>
                            <TableCell>{`${typeof entry.percent !== 'undefined' && entry.percent !== null ? entry.percent : 0}`}</TableCell>
                            {extraCols.map((propName) => (
                                <TableCell key={propName}>{`${entry[propName]}`}</TableCell>
                            ))}
                        </TableRow>
                    )),
                    // Ajouter une ligne pour la moyenne pour ce choix
                    choice.average !== undefined && (
                    <TableRow key={`${choiceIndex} - average`} style={{ backgroundColor: choiceIndex % 2 === 1 ? '#f0f0f0' : 'transparent' }}>
                        <TableCell>{`${choice.label && choices.length > 1 ? `${choice.label} -` : ''} Moyenne`}</TableCell>
                        <TableCell>{`${choice.average}`}</TableCell>
                        <TableCell></TableCell>
                        {extraCols.map(() => (
                        <TableCell></TableCell>
                        ))}
                    </TableRow>
                    ),
                    choice.nbVotes !== undefined && (
                    // Ajouter une ligne pour le total des votes pour ce choix
                    <TableRow key={`${choiceIndex} - nbVotes`} style={{ backgroundColor: choiceIndex % 2 === 1 ? '#f0f0f0' : 'transparent' }}>
                    <TableCell>{`${choice.label && choices.length > 1 ? `${choice.label} -` : ''} Total des votes`}</TableCell>
                    <TableCell>{`${typeof choice.nbVotes !== 'undefined' ? choice.nbVotes : 0}`}</TableCell>
                    <TableCell></TableCell>
                    {extraCols.map(() => (
                        <TableCell></TableCell>
                    ))}
                    </TableRow>
                    )
                ]) : [
                         <TableRow key="no-data">
                         <TableCell colSpan={extraCols.length + 3}>
                           Aucune donnée n'est disponible pour le moment.
                         </TableCell>
                       </TableRow>
                    ]}
                {globalNbVotes !== undefined && choices.length > 1 && (
                    // Ajouter une ligne pour le total des votes pour ce choix
                <TableRow key={`${Math.round} -nbTotalVotes`} style={{ backgroundColor: choices.length % 2 === 1 ? '#f0f0f0' : 'transparent' }}>
                <TableCell>{`Total des votes`}</TableCell>
                <TableCell>{`${globalNbVotes}`}</TableCell>
                <TableCell></TableCell>
                {extraCols.map(() => (
                    <TableCell></TableCell>
                ))}
                </TableRow>
                )}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
    </>
}

 
export default StatsTableView;